// import React, { useEffect, useState, useRef } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import {
//   getLogos,
//   getIcons,
//   titleName,
//   ProductName,
//   clientCompanyName,
// } from "../Constant/Constant";

// import FBLogin from "../shareableContainer/FBLogin";

// const AdminAppBar = () => {
//   const [isDashboardActive, setIsDashboardActive] = useState(false);
//   const [isAnalyticsActive, setIsAnalyticsActive] = useState(false);
//   const [isLeaddbActive, setIsLeaddbActive] = useState(false);
//   const [isReportActive, setIsReportActive] = useState(false);
//   const [ispipelineActive, setIsPipelineActive] = useState(false);
//   const [isSetupManage, setIsSetupManage] = useState(false);
//   const [isSetupMenuOpen, setIsSetupMenuOpen] = useState(false);
//   const logos = getLogos();
//   const icons = getIcons();
//   const location = useLocation();
//   const setupMenuRef = useRef(null);
//   const [isMarketingHubOpen, setIsMarketingHUbOpen] = useState(false);
//   const marketingHubRef = useRef(null);

//   const navigate = useNavigate();

//   useEffect(() => {
//     setIsDashboardActive(location.pathname.includes("/dashboard"));
//     setIsAnalyticsActive(location.pathname.includes("/analytics"));
//     setIsPipelineActive(location.pathname.includes("/pipeline"));
//     setIsLeaddbActive(location.pathname.includes("/lead-db"));
//     setIsReportActive(location.pathname.includes("/report"));
//     setIsSetupManage(location.pathname.includes("/set-up-manage"));
//   }, [location.pathname]);

//   const getRoleBasedPath = (path) => {
//     const userData = JSON.parse(localStorage.getItem("userData"));
//     const userRole = userData?.user?.role || "";

//     console.log("User role:", userRole);

//     let roleBasedPath;
//     switch (userRole) {
//       case "Admin":
//         roleBasedPath = `/admin${path}`;
//         break;
//       case "CMO":
//         roleBasedPath = `/cmo${path}`;
//         break;
//       case "MD":
//         roleBasedPath = `/md${path}`;
//         break;
//       case "BOD":
//         roleBasedPath = `/bod${path}`;
//         break;
//       default:
//         roleBasedPath = path;
//     }

//     console.log("Role-based path:", roleBasedPath); // Log the computed path
//     return roleBasedPath;
//   };

//   const handleNavigation = (path) => {
//     console.log("Click");
//     navigate(getRoleBasedPath(path));
//   };

//   const toggleSetupMenu = () => {
//     setIsSetupMenuOpen(!isSetupMenuOpen);
//     if (!isSetupMenuOpen) {
//       setIsMarketingHUbOpen(false);
//     }
//   };

//   const handleClickOutside = (event) => {
//     if (setupMenuRef.current && !setupMenuRef.current.contains(event.target)) {
//       setIsSetupMenuOpen(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleSignout = () => {
//     localStorage.clear();
//     window.location.reload();
//   };

//   const userData = JSON.parse(localStorage.getItem("userData"));
//   const userRole = userData?.user?.role || "";
//   const userName = userData?.user?.name || "";

//   const handleMarketingHub = (event) => {
//     event.stopPropagation();
//     setIsMarketingHUbOpen(!isMarketingHubOpen);
//   };

//   return (
//     <nav className="2xl:w-full xl:w-full  lg:w-full lg:gap-20 3xl:w-full md:w-full h-20 pt-4 fixed z-20 top-0 flex flex-row justify-between shadow-md bg-customAppBarBackground pb-2">
//       <div
//         className="lg:w-56   2xl:w-64 custom-xl:w-64  xl:w-56  flex cursor-pointer"
//         onClick={() => handleNavigation("/dashboard")}
//       >
//         <img
//           className="md:w-5 md:h-9 mx-4 2xl:w-10 2xl:h-12 custom-xl:w-12 custom-xl:h-12 xl:w-10 xl:h-10 lg:w-10 lg:h-10"
//           src={logos.glFunnelLogo}
//           alt=""
//         />
//         <span className="lg:text-2xl 2xl:text-3xl custom-xl:text-3xl 2xl:w-96 xl:text-2xl md:text-xl md:w-44 md:h-6 lg:w-44 lg:h-9 font-semibold text-customGreen mt-1">
//           {/* GL Funnel */}
//           {ProductName}
//         </span>
//       </div>
//       <div className="flex gap-10 lg:gap-7 2xl:w-96 2xl:gap-14 3xl:gap-16 xl:gap-10 justify-center text-center">
//         <div
//           className="flex flex-col justify-center items-center gap-2 cursor-pointer"
//           onClick={() => handleNavigation("/dashboard")}
//         >
//           <img
//             className={`lg:w-7 lg:h-7 2xl:w-8 2xl:h-8 3xl:w-8 3xl:h-8 xl:w-8 xl:h-7 md:w-7 md:h-7`}
//             src={
//               isDashboardActive
//                 ? icons.dashboardIconActive
//                 : icons.dashboardIcon
//             }
//             alt=""
//           />
//           <span className="font-medium text-sm">Dashboard</span>
//         </div>
//         <div
//           className="flex flex-col justify-center items-center gap-2 cursor-pointer"
//           onClick={() => handleNavigation("/analytics")}
//         >
//           <img
//             className={`lg:w-7 lg:h-7 md:w-7 md:h-7 2xl:w-8 2xl:h-8 xl:w-8 xl:h-7 3xl:w-8 3xl:h-8`}
//             src={
//               isAnalyticsActive
//                 ? icons.analyticsIconActive
//                 : icons.analyticsIcon
//             }
//             alt=""
//           />
//           <span className="font-medium text-sm">Analytics</span>
//         </div>
//         <div
//           className="flex flex-col justify-center items-center gap-2 cursor-pointer"
//           onClick={() => handleNavigation("/pipeline")}
//         >
//           <img
//             className={`lg:w-7 lg:h-7 md:w-7 md:h-7 2xl:w-8 2xl:h-8 xl:w-8 xl:h-7 3xl:w-8 3xl:h-8`}
//             src={
//               ispipelineActive ? icons.pipelineIconActive : icons.pipelineIcon
//             }
//             alt=""
//           />
//           <span className="font-medium text-sm">PipeLine</span>
//         </div>
//         <div
//           className="flex flex-col justify-center items-center gap-2 cursor-pointer"
//           onClick={() => handleNavigation("/lead-db")}
//         >
//           <img
//             className={`lg:w-7 lg:h-7 md:w-7 md:h-7 2xl:w-8 2xl:h-8 xl:w-8 xl:h-7 3xl:w-8 3xl:h-8`}
//             src={isLeaddbActive ? icons.leadDbIconActive : icons.leadDbIcon}
//             alt=""
//           />
//           <span className="font-medium text-sm 3xl:pb-1">LeadDB</span>
//         </div>
//         {(userRole === "Admin" || userRole === "CMO") && (
//           <div
//             className="flex flex-col justify-center items-center gap-2 cursor-pointer"
//             onClick={() => handleNavigation("/report")}
//           >
//             <img
//               className={`lg:w-7 lg:h-7 md:w-7 md:h-7 2xl:w-8 2xl:h-8 xl:w-8 xl:h-7 3xl:w-8 3xl:h-8`}
//               src={isReportActive ? icons.ReportIconActive : icons.ReportIcon}
//               alt=""
//             />
//             <span className="font-medium text-sm 3xl:pb-1">Report</span>
//           </div>
//         )}

//         {(userRole === "Admin" || userRole === "CMO") && (
//           <div>
//             <div
//               className="flex flex-col justify-center items-center gap-2 cursor-pointer"
//               // ref={setupMenuRef}
//               // onClick={toggleSetupMenu}
//             >
//               <img
//                 onClick={() => {
//                   const path = userRole === "Admin" ? "/admin" : "/cmo";
//                   navigate(`${path}/set-up-manage`);
//                 }}
//                 className={`lg:w-7 lg:h-7 md:w-7 md:h-7 2xl:w-8 2xl:h-8 xl:w-8 xl:h-7 3xl:w-8 3xl:h-8`}
//                 src={isSetupManage ? icons.setupIconActive : icons.setupIcon}
//                 alt=""
//               />
//               <span className="font-medium text-sm">Setup</span>
//               {/* {!isSetupMenuOpen && (
//             <div
//               className={`absolute ${
//                 userRole === "Admin" || userRole === "CMO"
//                   ? "mt-[430px]"
//                   : "mt-44"
//               } bg-white rounded-md shadow-md w-44 py-2`}
//             >
//               <ul className="list-none">
//                 {userRole === "MD" || userRole === "BOD" ? (
//                   <>
//                     <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={() => handleNavigation("/my-profile")}
//                     >
//                       <Link to="/my-profile">My Profile</Link>
//                     </li>
//                     <li
//                       className="py-2 text-center hover:text-[#399E79]"
//                       onClick={handleSignout}
//                     >
//                       <Link>Sign Out</Link>
//                     </li>
//                   </>
//                 ) : (
//                   <>
//                     <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={() =>
//                         navigate(
//                           `/${userRole === "Admin" ? "admin" : "cmo"}/sale-team`
//                         )
//                       }
//                     >
//                       <Link
//                         to={`/${
//                           userRole === "Admin" ? "admin" : "cmo"
//                         }/sale-team`}
//                       >
//                         Sales Teams
//                       </Link>
//                     </li>
//                     <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={() =>
//                         navigate(
//                           `/${userRole === "Admin" ? "admin" : "cmo"}/users`
//                         )
//                       }
//                     >
//                       <Link
//                         to={`/${userRole === "Admin" ? "admin" : "cmo"}/users`}
//                       >
//                         Users
//                       </Link>
//                     </li>
//                     <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={() =>
//                         navigate(
//                           `/${
//                             userRole === "Admin" ? "admin" : "cmo"
//                           }/cp-management`
//                         )
//                       }
//                     >
//                       <Link
//                         to={`/${
//                           userRole === "Admin" ? "admin" : "cmo"
//                         }/cp-management`}
//                       >
//                         CP Management
//                       </Link>
//                     </li>
                    
//                     <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={() =>
//                         navigate(
//                           `/${
//                             userRole === "Admin" ? "admin" : "cmo"
//                           }/properties-list`
//                         )
//                       }
//                     >
//                       <Link
//                         to={`/${
//                           userRole === "Admin" ? "admin" : "cmo"
//                         }/properties-list`}
//                       >
//                          properties
//                       </Link>
//                     </li>
//                     <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={() =>
//                         navigate(
//                           `/${
//                             userRole === "Admin" ? "admin" : "cmo"
//                           }/property-inventory`
//                         )
//                       }
//                     >
//                       <Link
//                         to={`/${
//                           userRole === "Admin" ? "admin" : "cmo"
//                         }/property-inventory`}
//                       >
//                         Property Inventory
//                       </Link>
//                     </li>
//                <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={() =>
//                         navigate(
//                           `/${userRole === "Admin" ? "admin" : "cmo"}/property`
//                         )
//                       }
//                     >
//                       <Link
//                         to={`/${
//                           userRole === "Admin" ? "admin" : "cmo"
//                         }/property`}
//                       >
//                         Properties
//                       </Link>
//                     </li> 

//                     <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={() =>
//                         navigate(
//                           `/${
//                             userRole === "Admin" ? "admin" : "cmo"
//                           }/interest-sources`
//                         )
//                       }
//                     >
//                       <Link
//                         to={`/${
//                           userRole === "Admin" ? "admin" : "cmo"
//                         }/interest-sources`}
//                       >
//                         Interest & Source
//                       </Link>
//                     </li>

                    
//                     <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={() =>
//                         navigate(
//                           `/${
//                             userRole === "Admin" ? "admin" : "cmo"
//                           }/web-hooks`
//                         )
//                       }
//                     >
//                       <Link
//                         to={`/${
//                           userRole === "Admin" ? "admin" : "cmo"
//                         }/web-hooks`}
//                       >
//                         Web Hooks
//                       </Link>
//                     </li>

//                     <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={
//                         handleMarketingHub
//                         // () => navigate(`/${userRole === "Admin" ? "admin" : "cmo"}/marketing-hub`)
//                       }
//                     >
//                       Marketing Hub
//                     </li>

//                     {isMarketingHubOpen && (
//                       <div
//                         className="absolute left-44 ml-2
//                       top-20 mt-9 bg-white rounded-md shadow-md w-44 py-2"
//                       >
//                         <ul className="list-none">
//                           <>
//                             <li
//                               className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                               onClick={() =>
//                                 navigate(
//                                   `/${
//                                     userRole === "Admin" ? "admin" : "cmo"
//                                   }/marketing-hub`
//                                 )
//                               }
//                             >
//                               Content Hub
//                             </li>
//                             <li
//                               className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                               onClick={() =>
//                                 navigate(
//                                   `/${
//                                     userRole === "Admin" ? "admin" : "cmo"
//                                   }/spin-wheel`
//                                 )
//                               }
//                             >
//                               Spin Wheel
//                             </li>
//                             <li
//                               className=" border-gray-300 py-2 text-center hover:text-[#399E79]"
//                               onClick={() =>
//                                 navigate(
//                                   `/${
//                                     userRole === "Admin" ? "admin" : "cmo"
//                                   }/gl-pages`
//                                 )
//                               }
//                             >
//                               GL Pages
//                             </li>
//                             <li
//                               className=" border-gray-300 py-2 text-center hover:text-[#399E79]"
//                               onClick={() =>
//                                 navigate(
//                                   `/${
//                                     userRole === "Admin" ? "admin" : "cmo"
//                                   }/auto-message`
//                                 )
//                               }
//                             >
//                               Automated Message
//                             </li>
//                           </>
//                         </ul>
//                       </div>
//                     )}
//                     <li
//                       className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                       onClick={() =>
//                         navigate(
//                           `/${
//                             userRole === "Admin" ? "admin" : "cmo"
//                           }/my-profile`
//                         )
//                       }
//                     >
//                       <Link
//                         to={`/${
//                           userRole === "Admin" ? "admin" : "cmo"
//                         }/my-profile`}
//                       >
//                         My Profile
//                       </Link>{" "}
//                     </li>
//                     <li className="py-2 text-center hover:text-[#399E79]">
//                       <Link onClick={() => handleSignout()}>Sign Out</Link>
//                     </li>
//                   </>
//                 )}
//               </ul>
//             </div>
//           )} */}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* <div>
//         <FBLogin />
//       </div> */}
//       <div className="flex 3xl:mr-10 2xl:mr-10 lg:w-fit custom-xl:mr-9 relative">
//         <div
//           ref={setupMenuRef}
//           onClick={toggleSetupMenu}
//           className="max-w-56 lg:max-w-fit cursor-pointer"
//         >
//           <span className="font-bold lg:text-lg md:text-base whitespace-nowrap">
//             Hi, {userName}
//           </span>
//           <br />
//           <span className="font-normal lg:text-base md:text-base whitespace-nowrap">
//             {clientCompanyName}
//           </span>
//         </div>

//         <div className="md:mx-8 lg:mr-8">
//           <img
//             className="lg:w-14 lg:h-14 md:w-10 md:h-10"
//             src={logos.clientLogo}
//             alt="Client Logo"
//           />
//         </div>
//         {isSetupMenuOpen && (
//           <div
//             className="absolute right-0 z-50 mt-[75px] bg-white rounded-md shadow-md w-44 py-2"
//             onMouseDown={(e) => e.stopPropagation()}
//           >
//             <ul className="list-none">
//               <li
//                 className="border-b border-gray-300 py-2 text-center hover:text-[#399E79]"
//                 onClick={() => {
//                   handleNavigation("/my-profile");
//                   setIsSetupMenuOpen(false); 
//                 }}
//               >
//                 Profile
//               </li>
//               <li
//                 className="py-2 text-center hover:text-[#399E79]"
//                 onClick={() => {
//                   handleSignout();
//                   setIsSetupMenuOpen(false); 
//                 }}
//               >
//                 Sign Out
//               </li>
//             </ul>
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// };

// export default AdminAppBar;

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getLogos,
  getIcons,

  
} from "../Constant/Constant";

import FBLogin from "../shareableContainer/FBLogin";
import { productName , clientCompanyName} from "../config/clientsConfig";

const NavItem = ({ icon, activeIcon, isActive, label, onClick }) => (
  <div
    className="flex flex-col justify-center items-center gap-1.5 cursor-pointer transition-all duration-200 hover:opacity-80"
    onClick={onClick}
  >
    <div className="p-2 rounded-full bg-opacity-10 hover:bg-gray-100">
      <img
        className="w-6 h-6 md:w-7 md:h-7 lg:w-7 lg:h-7 xl:w-7 xl:h-7 2xl:w-8 2xl:h-8"
        src={isActive ? activeIcon : icon}
        alt={`${label} icon`}
      />
    </div>
    <span className={`font-medium text-sm ${isActive ? "text-customGreen" : "text-gray-700"}`}>
      {label}
    </span>
  </div>
);

const AdminAppBar = () => {
  const [activeRoute, setActiveRoute] = useState("");
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const logos = getLogos();
  const icons = getIcons();
  const location = useLocation();
  const navigate = useNavigate();
  
  // User data from localStorage
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userRole = userData?.user?.role || "";
  const userName = userData?.user?.name || "";
  
  // Update active route based on current location
  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/dashboard")) setActiveRoute("dashboard");
    else if (path.includes("/analytics")) setActiveRoute("analytics");
    else if (path.includes("/pipeline")) setActiveRoute("pipeline");
    else if (path.includes("/lead-db")) setActiveRoute("lead-db");
    else if (path.includes("/report")) setActiveRoute("report");
    else if (path.includes("/set-up-manage")) setActiveRoute("setup");
  }, [location.pathname]);

  // Handle navigation with role-based routing
  const handleNavigation = (path) => {
    const baseRole = {
      "Admin": "/admin",
      "CMO": "/cmo",
      "MD": "/md",
      "BOD": "/bod"
    }[userRole] || "";
    
    navigate(`${baseRole}${path}`);
  };

  // Handle sign out
  const handleSignout = () => {
    localStorage.clear();
    window.location.reload();
  };

  // Close profile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".profile-menu-container")) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Navigation items configuration
  const navItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: icons.dashboardIcon,
      activeIcon: icons.dashboardIconActive,
      path: "/dashboard",
      visible: true
    },
    {
      id: "analytics",
      label: "Analytics",
      icon: icons.analyticsIcon,
      activeIcon: icons.analyticsIconActive,
      path: "/analytics",
      visible: true
    },
    {
      id: "pipeline",
      label: "Pipeline",
      icon: icons.pipelineIcon,
      activeIcon: icons.pipelineIconActive,
      path: "/pipeline",
      visible: true
    },
    {
      id: "lead-db",
      label: "LeadDB",
      icon: icons.leadDbIcon,
      activeIcon: icons.leadDbIconActive,
      path: "/lead-db",
      visible: true
    },
    {
      id: "report",
      label: "Report",
      icon: icons.ReportIcon,
      activeIcon: icons.ReportIconActive,
      path: "/report",
      visible: userRole === "Admin" || userRole === "CMO"
    },
    {
      id: "setup",
      label: "Setup",
      icon: icons.setupIcon,
      activeIcon: icons.setupIconActive,
      path: "/set-up-manage",
      visible: userRole === "Admin" || userRole === "CMO"
    }
  ];

  return (
    <nav className="w-full h-16 md:h-18 lg:h-20 fixed z-20 top-0 flex items-center justify-between px-6 shadow-md bg-white">
      {/* Logo section */}
      <div
        className="flex items-center cursor-pointer"
        onClick={() => handleNavigation("/dashboard")}
      >
        <img
          className="w-8 h-8 md:w-9 md:h-9 lg:w-10 lg:h-10 2xl:w-12 2xl:h-12"
          src={logos.glFunnelLogo}
          alt="Company Logo"
        />
        <span className="ml-2 text-xl md:text-2xl lg:text-2xl 2xl:text-3xl font-semibold text-customGreen">
          {productName}
        </span>
      </div>

      {/* Navigation Items */}
      <div className="flex items-center gap-4 md:gap-6 lg:gap-8 xl:gap-10 2xl:gap-12 justify-center">
        {navItems.filter(item => item.visible).map(item => (
          <NavItem
            key={item.id}
            icon={item.icon}
            activeIcon={item.activeIcon}
            isActive={activeRoute === item.id}
            label={item.label}
            onClick={() => handleNavigation(item.path)}
          />
        ))}
      </div>

      {/* User Profile */}
      <div className="flex items-center">
        {/* <div className="mr-4">
          <FBLogin />
        </div> */}
        
        <div className="profile-menu-container relative">
          <div 
            className="flex items-center cursor-pointer" 
            onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
          >
            <div className="text-right mr-2">
              <div className="font-bold text-base lg:text-lg">Hi, {userName}</div>
              <div className="text-sm lg:text-base text-gray-600">{clientCompanyName}</div>
            </div>
            
            <div className="flex-shrink-0">
              <img
                className="w-10 h-10 lg:w-12 lg:h-12 rounded-full border-2 border-gray-200"
                src={logos.clientLogo}
                alt="Client Logo"
              />
              <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border border-white"></div>
            </div>
          </div>

          {/* Profile dropdown menu */}
          {isProfileMenuOpen && (
            <div className="absolute right-0 mt-5 w-48 bg-white rounded-lg shadow-lg py-1 z-50">
              <div className="px-4 py-2 border-b border-gray-100">
                <p className="text-sm font-medium text-gray-900">{userName}</p>
                <p className="text-xs text-gray-500">{userRole}</p>
              </div>
              <button
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => {
                  handleNavigation("/my-profile");
                  setIsProfileMenuOpen(false);
                }}
              >
                Profile
              </button>
              <button
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={() => {
                  handleSignout();
                  setIsProfileMenuOpen(false);
                }}
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AdminAppBar;